export enum ContactMethod {
  EMAIL = '1',
  PHONE = '2',
  MAIL = '3',
}
